import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0695a62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-wrapper main-content-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "リッチメニュー一覧", -1))
const _hoisted_3 = { class: "menu" }
const _hoisted_4 = { class: "card-menu-list w-100 mt-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "データがありません", -1))
const _hoisted_6 = { class: "flex justify-content-between" }
const _hoisted_7 = { class: "flex justify-content-start" }
const _hoisted_8 = { class: "p-input-icon-left" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search icon-search" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-new-menu" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn-primary" }, "新規作成")
], -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "text-center" }

import { FilterMatchMode } from "primevue/api";
import { get, set } from "@vueuse/core";
import { ApiRichMenuBaseReq, IRichMenu } from "../typings";
import { onBeforeMount, ref, inject } from "vue";
import { RichMenuServices } from "../services";
import { useConfirm } from "primevue/useconfirm";
import { useToast } from "primevue/usetoast";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import moment from "moment";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import Tag from "primevue/tag";
import Toast from "primevue/toast";


export default /*#__PURE__*/_defineComponent({
  __name: 'RichMenu',
  setup(__props) {

const toast = useToast();

const clinicId = ref(0);
const confirm = useConfirm();

const errorMessage = ref<string>();
const onError = (error: any) => {
  errorMessage.value = error.response?.data?.errors;
};

const richMenus = ref<IRichMenu[]>();
const filters = ref({
  title: { value: null, matchMode: FilterMatchMode.CONTAINS },
});

const getSeverity = (richMenu: IRichMenu) => (richMenu.default_menu ? "success" : "warning");

const getStatus = (status: string) => (status ? "アクティブ" : "非アクティブ");

const getType = (type: string): string => (type == "tab_menu" ? "複数タブ" : "単一タブ");

const confirmDelete = (menuId: number): void => {
  confirm.require({
    message: "削除してもよろしいですか？",
    header: "注意",
    rejectLabel: "キャンセル",
    acceptLabel: "OK",
    acceptClass: "p-button-danger",
    accept: async () => {
      const params: ApiRichMenuBaseReq = {
        clinic_id: get(get(clinicId)),
      };
      const onSuccess = () => {
        const filteredMenus = get(richMenus)?.filter((menu: IRichMenu) => {
          if (menu.id != menuId) {
            return menu;
          }
        });

        set(richMenus, filteredMenus);
        toast.add({ severity: "success", detail: "削除完了", life: 3000 });
      };
      RichMenuServices.deleteRichMenu(menuId, params, onSuccess, onError);
    },
  });
};

const confirmPublish = (menuId: number) => {
  confirm.require({
    message: "このリッチメニューを設定してよろしいですか？",
    header: "このページの内容",
    rejectLabel: "キャンセル",
    acceptLabel: "登録",
    accept: async () => {
      const params: ApiRichMenuBaseReq = {
        clinic_id: get(get(clinicId)),
      };

      const onSuccess = () => {
        get(richMenus)?.forEach((menu: IRichMenu) => {
          if (menu.id == menuId) {
            menu.default_menu = true;
          } else {
            menu.default_menu = false;
          }
        });
        toast.add({ severity: "success", detail: "変更完了", life: 3000 });
      };

      RichMenuServices.publishRichMenu(menuId, params, onSuccess, onError);
    },
  });
};

const editMenu = (id: number) => {
  RouterUtils.goToWithParams(RouterConstants.RICH_MENU_EDIT_ROUTER_NAME, {
    id: id,
  });
};

onBeforeMount(async () => {
  await set(clinicId, await inject("clinicId"));
  const { data } = await RichMenuServices.getRichMenus({
    clinic_id: get(await get(clinicId)),
  });
  set(richMenus, get(await get(data)) as unknown as IRichMenu[]);
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(DataTable), {
          class: "p-0",
          paginator: "",
          paginatorPosition: "both",
          dataKey: "id",
          filterDisplay: "menu",
          value: richMenus.value,
          filters: filters.value,
          rows: 10,
          globalFilterFields: ['title']
        }, {
          empty: _withCtx(() => [
            _hoisted_5
          ]),
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_InputText, {
                    modelValue: filters.value['title'].value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value['title'].value) = $event)),
                    placeholder: "タイトル"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode(_component_router_link, {
                to: "rich-menu/new",
                class: "no-underline"
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), { header: "リッチメニューの画像" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("img", {
                  src: slotProps.data.image,
                  class: "w-6rem shadow-2 border-round"
                }, null, 8, _hoisted_11)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "タイトル",
              field: "title"
            }),
            _createVNode(_unref(Column), {
              header: "タイプ",
              field: "group_type"
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_unref(Tag), {
                  value: getType(slotProps.data.group_type),
                  severity: "info"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "ステータス" }, {
              body: _withCtx((slotProps) => [
                _createVNode(_unref(Tag), {
                  value: getStatus(slotProps.data.default_menu),
                  severity: getSeverity(slotProps.data)
                }, null, 8, ["value", "severity"])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "作成日時" }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_unref(moment)(slotProps.data.created_at).format("YYYY/MM/DD HH:MM")), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "アクションのボタン",
              headerClass: "text-center table-actions"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_Button, {
                    onClick: ($event: any) => (editMenu(slotProps.data.id)),
                    icon: "pi pi-pencil",
                    class: "mr-3 p-button-primary",
                    rounded: ""
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    onClick: ($event: any) => (confirmPublish(slotProps.data.id)),
                    icon: "pi pi-flag-fill",
                    class: "mr-3 p-button-secondary",
                    rounded: ""
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    onClick: ($event: any) => (confirmDelete(slotProps.data.id)),
                    icon: "pi pi-trash",
                    class: "p-button-danger",
                    rounded: ""
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "filters"]),
        _createVNode(_unref(Toast), { position: "top-center" })
      ])
    ])
  ]))
}
}

})